import { render, staticRenderFns } from "./compensation-modal.vue?vue&type=template&id=3d983fa6&scoped=true&"
import script from "./compensation-modal.vue?vue&type=script&lang=js&"
export * from "./compensation-modal.vue?vue&type=script&lang=js&"
import style0 from "./compensation-modal.vue?vue&type=style&index=0&id=3d983fa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d983fa6",
  null
  
)

export default component.exports